<div class="content-page">
  <div class="content">
    <div *ngIf="content.icon" class="img">
      <img [src]="'../../../../assets/svg/'+ content.icon +'.svg'" />
    </div>
    <h1>{{ content.title }}</h1>
    <span>{{ content.description }}</span>
    <bfd-divider *ngIf="content.button" [padding]="'small'"></bfd-divider>
    <bfd-button *ngIf="content.button" [text]="content.button" [type]="'primary-large'" (buttonClick)="dispatchEvent($event)"></bfd-button>
  </div>
</div>